module.exports = __webpack_public_path__ + "img/logo.f8e1f895.svg";